// extracted by mini-css-extract-plugin
module.exports = {"container":"AdmissionProcess_container__DQGKL","grid":"AdmissionProcess_grid__njRqC","card":"AdmissionProcess_card__oxED1","cardImg":"AdmissionProcess_cardImg__vtn5T"};